import React from 'react';
import { Container, Box } from '@mui/material';

const MinimalLayout = ({ children, maxWidth = 'sm', centered = true }) => {
  return (
    <Container maxWidth={maxWidth}>
      <Box sx={{ py: 4, minHeight: '100vh', display: centered ? 'flex' : 'block', alignItems: centered ? 'center' : 'stretch', justifyContent: centered ? 'center' : 'flex-start' }}>
        <Box sx={{ width: '100%' }}>
          {children}
        </Box>
      </Box>
    </Container>
  );
};

export default MinimalLayout;
